module.exports = __webpack_public_path__ + "static/media/blue-cloud.37595abf.png";